import React from 'react';
import styles from './UnavailableTag.module.scss';

/* Providers */
import { useShopContext } from '../../../shared/__providers__/ShopContext';

/* Interfaces */
import { TipProduct } from '../../interfaces/TipProduct';

interface UnavailableTagProps {}

export const UnavailableTag: React.FC<UnavailableTagProps> = () => {
  const { shop } = useShopContext();
  const tip = shop!.selectedProduct as TipProduct;

  return (
    <>
      {tip && (
        <div className={styles.unavailable}>
          <div className={styles.messageContainer}>
            <span className={styles.mainText}>
              {tip.checkAvailability().message}
            </span>
          </div>
        </div>
      )}
    </>
  );
};
